import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '@adsk/bim360-matrix-react-action-button';

import { callOrReturn, isGroupKey } from './utils';

class ActionCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this._handleSelect = this._handleSelect.bind(this);
  }

  render() {
    const {
      rowData,
      rowIndex,
      container,
      rowKey,
      actionOptions,
      onRowActionShow,
      onRowActionHide
    } = this.props;
    // grouping or frozen rows
    if (isGroupKey(rowData[rowKey]) || rowIndex < 0) return null;

    const options = callOrReturn(actionOptions, { rowData, rowIndex });
    return (
      <ActionButton
        container={container}
        options={options}
        onSelect={this._handleSelect}
        onShow={() => onRowActionShow({ rowData, rowIndex })}
        onHide={() => onRowActionHide({ rowData, rowIndex })}
      />
    );
  }

  _handleSelect(key) {
    const { rowData, rowIndex, onRowAction } = this.props;
    onRowAction && onRowAction({ key, rowData, rowIndex });
  }
}

ActionCell.propTypes = {
  rowData: PropTypes.object,
  rowIndex: PropTypes.number,
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  rowKey: PropTypes.string,
  actionOptions: PropTypes.oneOfType([
    PropTypes.arrayOf(ActionButton.optionPropType),
    PropTypes.func
  ]),
  onRowAction: PropTypes.func,
  onRowActionShow: PropTypes.func,
  onRowActionHide: PropTypes.func
};

export default ActionCell;
